export const AtlassianDesignLogoBrand = () => (
  <svg
    width="432"
    height="48"
    viewBox="0 0 432 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2305_8761)">
      <path
        d="M10.3 19.9003C9.80005 19.3003 9.00005 19.4003 8.60005 20.1003L0.100048 37.1003C-0.199952 37.8003 0.300048 38.6003 1.00005 38.6003H12.8C13.2 38.6003 13.5 38.4003 13.7 38.0003C16.3 32.7003 14.7 24.7003 10.3 19.9003Z"
        fill="url(#paint0_linear_2305_8761)"
      />
      <path
        d="M16.5001 4.5001C11.8001 12.0001 12.1001 20.3001 15.2001 26.6001C18.3001 32.9001 20.7001 37.6001 20.9001 38.0001C21.1001 38.4001 21.4001 38.6001 21.8001 38.6001H33.6001C34.4001 38.6001 34.8001 37.8001 34.5001 37.1001C34.5001 37.1001 18.6001 5.3001 18.2001 4.5001C17.9001 3.8001 16.9001 3.8001 16.5001 4.5001Z"
        fill="#0082FF"
      />
      <path
        d="M155 18.1004C155 22.3004 156.9 25.6004 164.6 27.1004C169.1 28.1004 170.1 28.8004 170.1 30.3004C170.1 31.8004 169.1 32.7004 165.9 32.7004C162.2 32.7004 157.8 31.4004 154.9 29.7004V36.5004C157.2 37.6004 160.2 38.9004 165.9 38.9004C173.9 38.9004 177 35.3004 177 30.1004M177 30.2004C177 25.2004 174.4 22.9004 166.9 21.3004C162.8 20.4004 161.8 19.5004 161.8 18.2004C161.8 16.6004 163.3 15.9004 166 15.9004C169.3 15.9004 172.5 16.9004 175.6 18.3004V11.8004C173.4 10.7004 170.1 9.90039 166.2 9.90039C158.8 9.90039 155 13.1004 155 18.3004"
        fill="#0050D3"
      />
      <path
        d="M257.4 10.1001V38.6001H263.5V16.9001L266 22.6001L274.6 38.6001H282.2V10.1001H276.2V28.5001L273.9 23.1001L267 10.1001H257.4Z"
        fill="#0050D3"
      />
      <path d="M218.8 10.1001H212.2V38.6001H218.8V10.1001Z" fill="#0050D3" />
      <path
        d="M204.6 30.1003C204.6 25.1003 202 22.8003 194.5 21.2003C190.4 20.3003 189.4 19.4003 189.4 18.1003C189.4 16.5003 190.9 15.8003 193.6 15.8003C196.9 15.8003 200.1 16.8003 203.2 18.2003V11.7003C201 10.6003 197.7 9.80029 193.8 9.80029C186.4 9.80029 182.6 13.0003 182.6 18.2003C182.6 22.4003 184.5 25.7003 192.2 27.2003C196.7 28.2003 197.7 28.9003 197.7 30.4003C197.7 31.9003 196.7 32.8003 193.5 32.8003C189.8 32.8003 185.4 31.5003 182.5 29.8003V36.6003C184.8 37.7003 187.8 39.0003 193.5 39.0003C201.4 39.0003 204.6 35.4003 204.6 30.1003Z"
        fill="#0050D3"
      />
      <path
        d="M103.6 10.1001V38.6001H117.2L119.3 32.4001H110.2V10.1001H103.6Z"
        fill="#0050D3"
      />
      <path
        d="M76.7001 10.1001V16.2001H84.0001V38.6001H90.7001V16.2001H98.6001V10.1001H76.7001Z"
        fill="#0050D3"
      />
      <path
        d="M67 10.1001H58.3L48.4 38.6001H56L57.4 33.8001C59.1 34.3001 60.9 34.6001 62.7 34.6001C64.5 34.6001 66.3 34.3001 68 33.8001L69.4 38.6001H77C76.9 38.6001 67 10.1001 67 10.1001ZM62.6 28.6001C61.3 28.6001 60.1 28.4001 59 28.1001L62.6 15.7001L66.2 28.1001C65.1 28.4001 63.9 28.6001 62.6 28.6001Z"
        fill="#0050D3"
      />
      <path
        d="M140.7 10.1001H132L122 38.6001H129.6L131 33.8001C132.7 34.3001 134.5 34.6001 136.3 34.6001C138.1 34.6001 139.9 34.3001 141.6 33.8001L143 38.6001H150.6L140.7 10.1001ZM136.3 28.6001C135 28.6001 133.8 28.4001 132.7 28.1001L136.3 15.7001L139.9 28.1001C138.8 28.4001 137.6 28.6001 136.3 28.6001Z"
        fill="#0050D3"
      />
      <path
        d="M242.7 10.1001H234L224.1 38.6001H231.7L233.1 33.8001C234.8 34.3001 236.6 34.6001 238.4 34.6001C240.2 34.6001 242 34.3001 243.7 33.8001L245.1 38.6001H252.7L242.7 10.1001ZM238.4 28.6001C237.1 28.6001 235.9 28.4001 234.8 28.1001L238.4 15.7001L242 28.1001C240.9 28.4001 239.6 28.6001 238.4 28.6001Z"
        fill="#0050D3"
      />
      <path
        d="M300.1 8H311.4C321.3 8 326.1 14.2 326.1 23.4C326.1 32.7 321.3 38.6 311.4 38.6H300.1V8ZM304.3 12V34.6H311.4C318.4 34.6 321.9 30.9 321.9 23.5C321.9 16.1 318.6 12 311.2 12H304.3Z"
        fill="#172B4D"
      />
      <path
        d="M342 38.9999C333.3 38.9999 329.5 33.9999 329.5 26.8999C329.5 19.8999 333.4 14.8999 340.5 14.8999C347.7 14.8999 350.5 19.8999 350.5 26.8999V28.6999H333.5C334.1 32.6999 336.6 35.1999 342.1 35.1999C344.8 35.1999 347.1 34.6999 349.2 33.8999V37.5999C347.3 38.5999 344.4 38.9999 342 38.9999ZM333.5 25.1999H346.5C346.3 20.8999 344.3 18.3999 340.3 18.3999C336.1 18.3999 333.9 21.1999 333.5 25.1999Z"
        fill="#172B4D"
      />
      <path
        d="M362.6 38.9998C359.1 38.9998 356.3 38.1998 354.5 37.2998V33.0998C356.5 34.2998 359.9 35.3998 362.8 35.3998C365.9 35.3998 367.5 34.0998 367.5 32.2998C367.5 30.4998 366.2 29.4998 361.7 28.3998C356.5 27.0998 354.3 25.0998 354.3 21.2998C354.3 17.2998 357.4 14.7998 362.7 14.7998C365.7 14.7998 368.5 15.4998 370.2 16.4998V20.5998C367.4 19.1998 365.1 18.4998 362.7 18.4998C359.8 18.4998 358.2 19.4998 358.2 21.2998C358.2 22.8998 359.3 23.9998 363.6 24.9998C368.8 26.2998 371.4 28.1998 371.4 32.1998C371.4 36.0998 368.8 38.9998 362.6 38.9998Z"
        fill="#172B4D"
      />
      <path
        d="M378 6.3999C379.6 6.3999 380.8 7.3999 380.8 9.1999C380.8 10.9999 379.6 11.9999 378 11.9999C376.4 11.9999 375.2 10.9999 375.2 9.1999C375.2 7.3999 376.4 6.3999 378 6.3999ZM376 15.2999H380V38.5999H376V15.2999Z"
        fill="#172B4D"
      />
      <path
        d="M401.7 34.3999C400.2 37.4999 397.4 39.0999 393.8 39.0999C387.7 39.0999 384.6 33.7999 384.6 26.9999C384.6 20.3999 387.8 14.8999 394.3 14.8999C397.7 14.8999 400.3 16.3999 401.7 19.4999V15.3999H405.6V36.5999C405.6 43.3999 402.4 47.9999 394.1 47.9999C390.2 47.9999 388.1 47.4999 385.8 46.6999V42.7999C388.4 43.5999 391 44.1999 393.9 44.1999C399.7 44.1999 401.7 41.0999 401.7 36.7999V34.3999ZM394.9 35.2999C398.5 35.2999 401.7 32.9999 401.7 27.8999V25.9999C401.7 20.7999 398.8 18.5999 395.4 18.5999C390.9 18.5999 388.6 21.5999 388.6 26.9999C388.5 32.4999 390.8 35.2999 394.9 35.2999Z"
        fill="#172B4D"
      />
      <path
        d="M431.4 38.4998H427.4V24.4998C427.4 20.2998 425.7 18.4998 421.9 18.4998C418.2 18.4998 415.6 20.9998 415.6 25.6998V38.5998H411.6V15.2998H415.6V19.0998C417.1 16.3998 419.8 14.7998 423 14.7998C428.4 14.7998 431.4 18.4998 431.4 24.8998V38.4998Z"
        fill="#172B4D"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2305_8761"
        x1="14.9161"
        y1="22.5567"
        x2="5.96115"
        y2="38.0667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0050D3" />
        <stop offset="0.923" stopColor="#0082FF" />
      </linearGradient>
      <clipPath id="clip0_2305_8761">
        <rect width="432" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
